import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { POPOVER_DATA, PopoverComponent, SHARED_MODULES } from '@app/shared';

export enum TypeHelpActivityEnum {
  Eclass,
  Late,
  Evaluative,
}

@Component({
  selector: 'app-popover-activity',
  templateUrl: './popover-activity.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SHARED_MODULES, PopoverComponent],
})
export class PopoverActivityComponent {
  public readonly type: TypeHelpActivityEnum = inject(POPOVER_DATA);
  public TypeHelpActivityEnum = TypeHelpActivityEnum;
}
